import { logDebug } from '../logger';
export const logReceivedEvent = event => logDebug(`Received ${event.type} event:\n\t`, event);
//# sourceMappingURL=logReceivedEvent.js.map